import { useEffect, useState } from 'react';
import { Recording } from '@hotjar/webapp/features/Playbacks/types';
import { ConsoleEvent, EVENT_TYPE } from '../types';

export const useConsoleEventList = (recording: Recording | undefined | null): ConsoleEvent[] => {
  const [events, setEvents] = useState<ConsoleEvent[]>([]);

  useEffect(() => {
    if (!recording) return;

    const events = recording.page_visit_recordings.reduce((acc, page) => {
      const errors = page.events.reduce((list, e) => {
        if (e.type !== 'error') return list;
        return [...list, { type: EVENT_TYPE.ERROR, event: e }];
      }, [] as ConsoleEvent[]);

      if (!errors.length) return acc;

      const navigationEvent = {
        type: EVENT_TYPE.NAVIGATION,
        event: {
          id: 0,
          text: page.page_url,
          time_in_timeline: page.time_in_timeline,
          timestamp: page.time_in_timeline,
          time: page.time_in_timeline,
          type: '',
        },
      };

      return [...acc, navigationEvent, ...errors];
    }, [] as ConsoleEvent[]);

    setEvents(events);
  }, [recording]);

  return events;
};
